import { useCreateProductAdjustment } from 'api-hooks/product/adjustment/mutation';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import useDismiss from 'hooks/use-dismiss';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';

import ProductAdjustmentForm from './components/form';

export default function ProductAdjustmentCreate(props) {
  const { navigate } = useNavigation();

  const { mutateAsync, error } = useCreateProductAdjustment();

  const onDismiss = useDismiss('product-adjustments');
  const permission = useGetCrudPermission('product-adjustments');

  return (
    <>
      <ProductAdjustmentForm
        {...props}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          onDismiss();

          if (permission.view) {
            navigate(NavigationRoutes.ProductAdjustmentView, {
              id: result.data?.id,
            });
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
